import * as React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import dayjs from "dayjs";
import Link from "next/link";

const MarchMadnessLatestPosts = ({ posts, backgroundColor }) => {
  return (
    <Row
      style={{
        display: "flex",
        alignItems: "stretch",
        marginBottom: "300px",
        width: "100%",
        padding: "0px",
        backgroundColor: backgroundColor ? backgroundColor : "#f3f4f6",
      }}
      className="justify-content-md-center"
    >
      {posts.map((post) => {
        const formattedExcerptText = post.post?.excerpt
          ?.match(/^.*(<a class="more-link")/gi)?.[0]
          ?.replace(/<p>|<a class="more-link"|&hellip;|&nbsp;/gim, "")
          .split(" ")
          .slice(3, 40)
          .join(" ")
          .concat(" ...");
        return (
          <Col
            key={post?.post?.slug}
            sm={12}
            md={7}
            lg={4}
            style={{ height: "fit-content", paddingLeft: 60, paddingRight: 60 }}
          >
            <div className="mm-card">
              <img
                style={{ height: "200px", width: "100%", borderRadius: "12px", objectFit: "cover" }}
                src={post?.post.featuredImage?.node?.sourceUrl}
                alt=""
              />
              <p className="mm-card-date">{dayjs(post.post.date).format("LL")}</p>
              <h2 className="mm-card-title">{post.post.title}</h2>
              <p
                dangerouslySetInnerHTML={{ __html: !formattedExcerptText ? post?.post?.excerpt : formattedExcerptText }}
              />
              <Link href={`/post/${post.post.slug}`} className="stretched-link" />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default MarchMadnessLatestPosts;
